import { Router } from '@angular/router';
import { FinalComponent } from './pages/final/final.component';
import { ItemApprovalComponent } from './pages/item-approval/item-approval.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { HttpClientModule } from '@angular/common/http';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { ProductListComponent } from './component/product-list/product-list.component';
import { ProductSubsComponent } from './component/product-subs/product-subs.component';
import { OrderOutOfStockListComponent } from './component/order-out-of-stock-list/order-out-of-stock-list.component';
import { OrderAddonItemListComponent } from './component/order-addon-item-list/order-addon-item-list.component';
import { GtagModule } from 'angular-gtag';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';
import { CustomersChoiceComponent } from './component/customers-choice/customers-choice.component';

@NgModule({
  declarations: [
    AppComponent,
    ItemApprovalComponent,
    FinalComponent,
    PageNotFoundComponent,
    WelcomeComponent,
    ErrorPageComponent,
    ProductListComponent,
    ProductSubsComponent,
    OrderOutOfStockListComponent,
    OrderAddonItemListComponent,
    CustomersChoiceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    GtagModule.forRoot({ trackingId: environment.gaTrackingId, trackPageviews: true })
  ],
  providers: [
    // Senrty start
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        logErrors: true,
        showDialog: true
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    // Sentry end
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => {
        const baseUrl = s.getBaseHrefFromDOM();

        if (baseUrl[baseUrl.length - 1] == '/') {
          var trimmedUrl = baseUrl.substring(0, baseUrl.length - 1);
          return trimmedUrl;
        }

        return baseUrl;
      },
      deps: [PlatformLocation]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(trace: Sentry.TraceService) {}
}
